<div class="layout-col full">
  <ng-template elderToolbarColumn="right.actions">
    <app-view-mode-context-menu></app-view-mode-context-menu>
  </ng-template>
  <ng-template elderToolbarColumn="center">
    @if (ctx$ | async; as ctx) {
      @switch (ctx?.viewMode) {
        @case (ViewMode.PREVIEW) {
          <app-interval-context-menu></app-interval-context-menu>
        }
        @case (ViewMode.LIVE) {
          <span>{{ ctx?.liveTimestamp?.toString() | date: 'medium' }}</span>
        }
      }
    }
  </ng-template>

  <elder-grid
    class="flex"
    [data]="dataContext"
    [itemHeight]="350"
    [toolbarVisible]="false"
    [selectionVisible]="false"
    (itemClick)="openShopfloorUtilisation($event)"
  >
    <!-- Grid Tile Template -->
    <ng-container *elderGridTile="let utilization">
      @if (coerceUtilization(utilization); as asyncUtilization) {
        <div class="layout-col">
          <div class="flex layout-col place-center-center">
            <div class="layout-row place-center-center gap-sm">
              <span class="flex"></span>

              <h3 class="text-title-small">{{ asyncUtilization?.facility?.name }}</h3>

              @if (asyncUtilization.hasUnassigned() || asyncUtilization.hasOvercapacity()) {
                <mat-icon [color]="'warn'">
                  {{ 'warning' }}
                </mat-icon>
              }

              @if (asyncUtilization.state === AsyncState.LOADING) {
                <div class="flex place-center-center">
                  <mat-progress-spinner
                    [color]="'primary'"
                    [mode]="'indeterminate'"
                    [diameter]="20"
                  ></mat-progress-spinner>
                </div>
              }
            </div>

            @if (asyncUtilization.utilisation$ | async; as utilisation) {
              <app-utilisation-progress-bar
                class="flex"
                [facilityUtilisation]="utilisation"
                [barThickness]="12"
              >
              </app-utilisation-progress-bar>
            }
          </div>

          <div class="layout-col gap-sm p-xxl">
            @for (wutil of asyncUtilization.getMostUtilizedWC(4); track wutil) {
              <div class="layout-col place-center-stretch">
                @if (wutil.capacity === 'PT0S') {
                  <div class="layout-row place-between-center gap-sm">
                    <span class="mat-caption"
                      >{{ wutil.workCenterNumber }} {{ wutil.workCenterName }}</span
                    >
                    <div class="layout-row place-center-center gap-sm">
                      <mat-icon [color]="wutil.capacityUsage > 0.0 ? 'warn' : 'primary'">
                        {{ wutil.capacityUsage > 0.0 ? 'warning' : 'info' }}
                      </mat-icon>
                      <span class="mat-caption">{{ 'context.unavailable' | translate }}</span>
                    </div>
                  </div>
                } @else {
                  <app-utilisation-capacity-bar [workCenterUtilisation]="wutil">
                  </app-utilisation-capacity-bar>
                  <div class="flex layout-row place-between-center">
                    <span class="mat-caption"
                      >{{ wutil.workCenterNumber }} {{ wutil.workCenterName }}</span
                    >
                    <span class="mat-caption">{{ percent(wutil.capacityUsage) }}</span>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </ng-container>
  </elder-grid>
</div>
